module.exports = __webpack_public_path__ + "img/broom.b2b7f072.svg";